<template>
    <Layout>
        <Spinner v-if="loading" class="spinner--transparent"></Spinner>
        <StaticContent :content="content" />
    </Layout>
</template>

<script>
import Layout from '@speechki-frontend/shared/ui/layout/Layout';
import StaticContent from '@speechki-frontend/shared/ui/StaticContent';

export default {
    name: 'StaticPage',
    components: {
        Layout,
        StaticContent
    },
    data() {
        return {
            content: '',
            loading: true
        };
    },
    watch: {
        '$route.params.slug': {
            immediate: true,
            handler() {
                this.content = '';
                this.loading = true;
                let modifier = this.$i18n.locale === 'eng' ? '-en' : '';
                this.$http
                    .get(`/api/v1/information/docs-${this.$route.params.slug}${modifier}/`)
                    .then(response => {
                        this.content = response.data;
                        this.$nextTick(() => {
                            this.loading = false;
                        });
                    })
                    .catch(error => {
                        if (error.status === 404) {
                            this.$http
                                .get(`/api/v1/information/docs-${this.$route.params.slug}/`)
                                .then(response => {
                                    this.content = response.data;
                                    this.$nextTick(() => {
                                        this.loading = false;
                                    });
                                })
                                .catch(error => {
                                    if (error.status === 404) {
                                        this.$router.push('/404');
                                    }
                                });
                        }
                    });
            }
        }
    }
};
</script>
